import { DEFAULT_MATCH_THRESHOLDS } from "Pages/TalentMobilityV2/talentMobility.constants";

/**
 * getScoreColor
 *
 * Maps a 0-100 match/readiness score to an SbTag-compatible AntD color name,
 * against admin-configurable green/red thresholds (default 80 / 50 — see
 * talentMobility.constants.js). Anything between the two thresholds renders
 * amber ("warning"). No such score→color convention exists anywhere else in
 * this codebase yet — this is the canonical place to extend it if other
 * modules need the same banding later.
 */
export const getScoreColor = (score, thresholds = DEFAULT_MATCH_THRESHOLDS) => {
  if (score == null) return "default";
  if (score >= thresholds.green) return "success";
  if (score < thresholds.red) return "error";
  return "warning";
};

export const getScoreHex = (score, thresholds = DEFAULT_MATCH_THRESHOLDS) => {
  const color = getScoreColor(score, thresholds);
  if (color === "success") return "#28A745";
  if (color === "error") return "#DC2626";
  if (color === "warning") return "#B45309";
  return "#8c8c8c";
};
